import {animate, query, stagger, state, style, transition, trigger} from '@angular/animations';


export const fadeIn = trigger('fadeIn', [
  state('void', style({opacity: 0})),
  transition(':enter', animate('300ms ease-in')),
  // transition(':leave', animate('300ms ease-in'))
]);

export const listAnimation = trigger('listAnimation', [
  transition('* <=> *', [
      query(':enter',
        [
          style({
            opacity: 0
          }),
          stagger(200,
            animate('0.2s ease-out',
              style({
                opacity: 1
              })))],
        {optional: true}
      ),
      query(':leave',
        [
          style({
            opacity: 1
          }),
          stagger(200,
            animate('0.2s ease-out',
              style({
                opacity: 0
              })))],
        {optional: true}
      ),
    ]
  )
]);


export const listAnimationInstantLeave = trigger('listAnimationInstantLeave', [
  transition('* <=> *', [
      query(':enter',
        [
          style({
            opacity: 0
          }),
          stagger(200,
            animate('0.2s ease-out',
              style({
                opacity: 1
              })))],
        {optional: true}
      ),
      query(':leave',
        [
          style({
            opacity: 1
          }),
          stagger(200,
            animate('0.2s ease-out',
              style({
                opacity: 0
              })))],
        {optional: true}
      ),
    ]
  )
]);



export const fadeAnimation = trigger('fadeAnimation', [
  transition(':enter', [
    style({
      opacity: 0,
    }),
    animate('800ms', style({
      opacity: 1,
    })),
    animate(1000)
  ]),
  // transition(':leave', [
  //   animate(200, style({
  //     transform: 'scale(1.05)',
  //   })),
  //   animate(200, style({
  //     transform: 'scale(0.75)',
  //     opacity: 0.7
  //   })),
  //   animate('500ms ease-out', style({
  //     transform: 'scale(0.5)',
  //     opacity: 0
  //   }))
  // ])
])

export const countAnimation = trigger('count', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('1s', style({ opacity: 1 })),
  ]),
]);
